'use client'

import ReactMarkdown from 'react-markdown'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Image from './Image'
import { useLocale } from 'next-intl'
import type { Locale } from '@/i18n'
import type { SanityImageAsset } from '@/.generated/sanityTypes/graphql'

type CarouselProps = {
  assets: SanityImageAsset[]
  className?: string
  slideContainerClassName?: string
  showArrows?: boolean
  showIndicators?: boolean
  onChange?: (index: number) => void
  selectedItem?: any
  dynamicHeight?: boolean
  objectFit?: string
  autoPlay?: boolean
  imageStyle?: any
  containerStyle?: any
}

const Carousel = ({
  assets,
  className = '',
  showArrows = true,
  showIndicators = true,
  dynamicHeight = true,
  objectFit,
  onChange,
  selectedItem = 0,
  autoPlay = false,
  imageStyle = {},
  containerStyle = {},
  slideContainerClassName,
}: CarouselProps) => {
  const locale = useLocale() as Locale

  return (
    <Slider
      className={className}
      dots={showIndicators || true}
      infinite={true}
      touchMove={true}
      swipeToSlide={true}
      adaptiveHeight={dynamicHeight}
      arrows={showArrows}
      autoplay={autoPlay}
      autoplaySpeed={3000}
      afterChange={onChange}
      initialSlide={selectedItem}
    >
      {assets.map((asset) => {
        return (
          <div
            key={asset._id || asset._key}
            className={slideContainerClassName}
            style={containerStyle}
          >
            <div
              className="relative inline-block overflow-hidden align-top"
              style={{ objectFit: { objectFit }, ...imageStyle }}
            >
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <Image
                image={asset}
                className="relative inline-block overflow-hidden align-top"
                style={{ objectFit: { objectFit }, ...imageStyle }}
              />
            </div>

            {/* @ts-ignore */}
            {asset.title && asset.title[locale] && (
              <div className="absolute bottom-0 w-full pb-10 pt-4 text-center text-white">
                <div className="absolute bottom-0 top-0 w-full bg-black opacity-25"></div>
                <div className="text-md relative px-3 leading-snug text-white sm:leading-normal">
                  {/* @ts-ignore */}
                  <ReactMarkdown>{asset.title[locale]}</ReactMarkdown>
                </div>
              </div>
            )}
          </div>
        )
      })}
    </Slider>
  )
}

export default Carousel
